import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, Tabs, Tab, Typography, Drawer } from "@mui/material";
import ApprovalListComponent from "./ApprovalListComponent";
import { handleGetAllApprovalList, handleGetApprovalAnalytics, handleSearchGroupByName, handleUpdateGroupListOrder } from "../../../appStore/actions/ArkchatGroup/action";
import ApprovalAnalytics from "./ApprovalAnalytics";
import { useTranslation } from "react-i18next";
import HelperScreen from "../../../common/ToolTip/HelperScreen";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { APPROVAL_FILTER_QUERY_CONFIG, approvalsidebarmenu } from "../../../utils/constant";
import { colorSchemes, commonButtonHeight, TaskDetailWidth, TaskFilterWidth } from "../../../assets/commonFunction";
import filterinactive from "../../../assets/images/task/filterinactive.svg";
import filteractive from "../../../assets/images/task/filteractive.svg";
import groupinactive from "../../../assets/images/task/groupinactive.svg";
import groupactive from "../../../assets/images/task/groupactive.svg";
import sidebarleft from "../../../assets/images/task/sidebarleft.svg";
import sidebarright from "../../../assets/images/task/sidebarright.svg";
import dragIcon from "../../../assets/images/task/dragicon.svg";
import { createStyledIndicatorButton, StyledSideBarGroupBox } from "../../../common/StyledComponents/SideBarComponents";
import { ChatSearchButton, CustomInput, SearchBox, SmallIcon, } from "../../../common/chatComponents/ScreenSearchSection";
import searchIcon from "../../../assets/images/chats/searchIcon.svg";
import { closestCenter, DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import Filter from "../../task/Filter/Filter";
import ApprovalListPage from "./ApprovalListPage";
import group_icon from "../../../assets/images/chats/group_icon.svg";
import ProfileDetailModal from "../../../common/ProfileDetailModal";
import TaskTeamList from "../Task/Drawer/TaskTeamList";
import TaskTopicList from "../Task/Drawer/TaskTopicList";
import { useGroupTaskApprovalLogic } from "../../../customHooks/useGroupTaskApprovalLogic";

const classes = {
  sidebarbox: {
    marginLeft: "0.8rem",
    gap: "0.4rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px 12px 15px 12px !important",
    maxHeight: "30px",
    lineHeight: "normal",
    border: "1px solid #000000",
    borderRadius: "0.5px",
    background: "#fff",
    width: "100px",
    height: commonButtonHeight,
  },
  sidebarbox_img: {
    width: "23px",
    height: "23px",
    cursor: "pointer",
  },
  Tabs_01: {
    alignItems: "center",
    minHeight: "38px",

    minWidth: "152px",
    "& .MuiTabs-flexContainer": {
      // gap: "0 10px",
    },
    "& .MuiTab-root.Mui-selected": {
      background: "#183243",
      color: "#fff",
    },
  },
  taskApprovalSidebar: {
    // marginLeft: "0.8rem",
    width: TaskFilterWidth,
  },

  tab1: {
    color: "#183243",
    textTransform: "none",
    minWidth: "unset",
    minHeight: "1.8rem",
    marginRight: "0.5rem",
    display: "flex",
    flexDirection: "row",
    // borderRadius: "3px",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px 12px 15px 12px !important",
    maxHeight: "30px",
    lineHeight: "normal",
    background: "#D9D9D9",

    "&:first-Child": {
      borderTopLeftRadius: "3px",
      borderBottomLeftRadius: "3px",
    },
    "&:nth-Child(2)": {
      borderTopRightRadius: "3px",
      borderBottomRightRadius: "3px",
    },
    img: {
      margin: "0 !important",
    },
    "&.Mui-selected": {
      // color: "black",
    },
    "@media (max-width: 64em)": {
      // marginRight: "2.5rem",
    },
  },

  Tabs: {
    minHeight: "38px",
    alignItems: "center",
    "& .MuiTabs-flexContainer": {
      // gap: "0 10px",
    },
    "@media (max-width: 63em)": {
      "& .MuiTabs-flexContainer": {
        // gap: "0 3%",
      },
    },
    "& .MuiTab-root.Mui-selected": {
      background: "#183243",
      color: "#fff",
    },
  },

  tabs: {
    marginLeft: "0.5rem",
    minWidth: "unset",
    color: "#183243",
    textTransform: "none",
    minHeight: "1.8rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px 12px 15px 12px !important",
    maxHeight: "30px",
    lineHeight: "normal",
    background: "#fff",
    borderRadius: "3px",
    border: "1px solid #000000",
  },
  analyticsParentBox: {
    overflow: "scroll",
    height: "calc(100vh - 10rem)",
    "&::-webkit-scrollbar": {
      width: "1px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#F9F8F8",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "grey",
    },
  },
};

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index} style={{ height: "100%" }}>
    {value === index && children}
  </div>
);

// Sortable Item Component
const SortableItem = ({
  item,
  selectedTaskTabGroup,
  handleSelectTaskTabGroup,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item?.id + "groupListApproval" });
  const SmallActionButton = createStyledIndicatorButton("#E3E1E1");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [profileViewData, setProfileViewData] = useState("");

  const style = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
    width: "100%",
  };

  const handleGroupProfileBadgeClick = (
    data,
    isGroup,
    isBuyerSellerGroup = false,
  ) => {
    const viewData = {
      companyName:
        data?.accountDetails?.subscriberFirmName ||
        data?.activeSubscriber?.subscriberFirmName,
      userName: isGroup
        ? null
        : data?.name || `${data?.firstName} ${data?.lastName}`,
      industryName:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.activeSubscriber?.subscriberAccountIndustry,
      cityName: data?.accountDetails?.city || data?.city,
      industry:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.subscriberAccountIndustry,
      type:
        data?.accountDetails?.subscriberAccountType ||
        data?.subscriberAccountType,
      countryName: data?.accountDetails?.country || data?.country,
      profileBrief: data?.accountDetails?.profileBrief || data?.profileBrief,
      profileImgUrl: data?.accountDetails?.profileImgUrl || data?.profileImgUrl,
      coverImgUrl: data?.accountDetails?.coverImgUrl || data?.coverImgUrl,
      isGroup,
      isBuyerSellerGroup,
      website: data?.accountDetails?.website || data?.website,
      linkedin: data?.accountDetails?.linkedin || data?.linkedin,
      joinedDate: data?.joinedDate
        ? new Date(
          Number(String(data?.joinedDate).slice(0, 13)),
        ).toLocaleDateString()
        : data?.joinedDate,
      memberCount: data?.memberCount,
      createdDate: data?.createdDate
        ? new Date(
          Number(String(data?.createdDate).slice(0, 13)),
        ).toLocaleDateString()
        : data?.createdDate,
      groupName: data?.name,
      groupOwner: data?.createdByUserDetails
        ? `${data.createdByUserDetails.firstName || ""} ${data.createdByUserDetails.lastName || ""
          }`.trim()
        : "-",
      description: data?.description,
      email: data?.createdByUserDetails?.email,
    };
    setProfileViewData(viewData);
    setProfileViewModal(true);
  };

  const isSelected = selectedTaskTabGroup?.id === item?.id;

  return (
    <div ref={setNodeRef} style={style}>
      <ProfileDetailModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
        setProfileViewData={setProfileViewData}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          alignSelf: "center",
          justifyContent: "center",
        }}
      >
        {/* Left side icon */}
        <Box width="15%">
          <SmallActionButton
            size="small"
            variant="contained"
            sx={{
              padding:
                item?.accountDetails?.profileImgUrl && !item?.isGroup
                  ? "0px"
                  : "6px",
              overflow: "hidden",
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering item click
              item?.isGroup
                ? handleGroupProfileBadgeClick(
                  item,
                  item?.isGroup,
                  item?.isBuyerSellerGroup,
                )
                : handleGroupProfileBadgeClick(item, item?.isGroup);
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src={group_icon}
              alt="group"
            />
          </SmallActionButton>
        </Box>

        {/* Right side text */}
        <Box
          width="84%"
          sx={{
            backgroundColor: isSelected ? "#E1E1E1" : "transparent",
            borderRadius: "0.2rem",
            padding: "0.3rem 0.4rem",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: isSelected ? "#D6D6D6" : "#f5f5f5",
            },
          }}
          onClick={() => handleSelectTaskTabGroup(item)}
        >
          <Typography
            flex={1}
            fontSize="13px"
            fontWeight="400"
            color="black"
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              lineHeight: "1.4",
            }}
          >
            {item?.name}
          </Typography>
        </Box>

        {/* Drag handle */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginRight="0.3rem"
          sx={{
            cursor: "grab",
            padding: "0.2rem",
            borderRadius: "0.1rem",
            userSelect: "none",
            touchAction: "none",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
            "&:active": {
              cursor: "grabbing",
            },
          }}
          {...attributes}
          {...listeners}
        >
          <img
            src={dragIcon}
            alt="dragIcon"
            style={{
              width: "16px",
              height: "16px",
              opacity: 0.6,
            }}
          />
        </Box>
      </div>
    </div>
  );
};

const ApprovalListTab = ({
  setShowSidebar,
  handleClickTaskUpdate,
  filterActive,
  setFilterActive,
  handleViewThreadClick,
  setSideBarOpen,
  setGroupActive,
  groupActive,
  sidebarLeft,
  setSidebarLeft,
  handlegroupItemclick,
  // handleClearFilter,
  currentHomeIndexTab,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData } = useAppSelectors();
  const {
    selectedTabGroup,
    buttonDrawer,
    selectedGroupTopic,
    groupTopicList,
    groupSubtopicList,
    recipientDetails,
    filterChecked,
    tabValue,
    viewTabValue,
    selectedMember,
    selectedDateRange,
    setSelectedDateRange,

    handleSelectTabGroup,
    handleCheckedFilter,
    handleClearFilter,
    handleApplyTaskFilter,
    handleSelectMemberCheck,
    handleSelectGroupTopic,
    handleTabClick,
    handleChange,
    handleSidebarClick,
    handlecloseTeamlist,
    handlecloseTopiclist,
    handleViewChange,
  } = useGroupTaskApprovalLogic({
    listApi: handleGetAllApprovalList,
    analyticsApi: handleGetApprovalAnalytics,
    filterConfig: APPROVAL_FILTER_QUERY_CONFIG,
    currentUserData,
    setFilterActive,
    setSideBarOpen,
    setGroupActive,
    filterActive,
    groupActive,
    setSidebarLeft,
    sidebarLeft,
    setShowSidebar,
  });

  const dispatch = useDispatch();
  const groupList = useSelector((state) =>
    state?.arkchatgroup?.groupList?.filter((item) => item?.isGroup),
  );
  const cloneGroupList = useSelector(
    (state) => state?.arkchatgroup?.cloneGroupList,
  );

  const approvalTabGroupList = useSelector(
    (state) => state?.arkchatgroup?.allGroupAnalytics?.data,
  );

  const [activeId, setActiveId] = useState(null);

  const boxStyle = {
    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem",
  };

  // Drag and Drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 0, // Minimum distance to start dragging
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  // Drag and Drop handlers
  const handleDragEnd = (event) => {
    const { active, over } = event;

    // Clear active ID and restore scrolling after drag ends
    setActiveId(null);
    document.body.style.overflow = "auto";

    if (active.id !== over.id) {
      const oldIndex = groupList.findIndex(
        (item, index) =>
          item?.id + "groupList" + index + "unique" === active.id,
      );
      const newIndex = groupList.findIndex(
        (item, index) => item?.id + "groupList" + index + "unique" === over.id,
      );

      const reorderedGroupList = arrayMove(groupList, oldIndex, newIndex);
      dispatch(handleUpdateGroupListOrder(reorderedGroupList));
    }
  };



  const handleOnSearchGroup = (event) => {
    const { value } = event.target;

    if (value) {
      const FilterdGroup = cloneGroupList?.filter((item) =>
        item?.name?.toLowerCase().includes(value.toLowerCase()),
      );
      dispatch(handleSearchGroupByName(FilterdGroup));
    } else {
      dispatch(handleSearchGroupByName(cloneGroupList));
    }

    // handleSearchGroupByName
  };

  return (
    <>
      {!currentUserData?.tooltipApprovalScreenWeb && (
        <HelperScreen
          title={"How Approval works"}
          updateKey={"tooltip_approval_screen_web"}
          contactSections={[
            {
              heading: "Okay, approved in a chat is not an approval.",
              content: [
                "It's a liability. Arkchat converts messages into formal approval requests - tracked, updated, and documented. So nothing gets missed, denied, or disputed later.",
              ],
            },
          ]}
        />
      )}

      <Box width="100%">
        <Stack direction={"row"} width="100%">
          <Box direction={"column"} gap={"0.2rem"} width="100%">
            <Box
              direction="row"
              display={"flex"}
              gap={"0.2rem"}
              alignItems="center"
              width="100%"
            >
              {viewTabValue !== 0 && (
                <Box sx={classes.sidebarbox}>
                  <img
                    onClick={() => {
                      handleSidebarClick("filter");
                    }}
                    src={filterActive ? filteractive : filterinactive}
                    style={classes.sidebarbox_img}
                    alt="filter"
                  />
                  <img
                    onClick={() => {
                      handleSidebarClick("group");
                    }}
                    src={groupActive ? groupactive : groupinactive}
                    style={classes.sidebarbox_img}
                    alt="group"
                  />
                  <img
                    onClick={() => {
                      handleSidebarClick("sidebarleft");
                    }}
                    src={sidebarLeft ? sidebarleft : sidebarright}
                    style={classes.sidebarbox_img}
                    alt="sidebarleft"
                  />
                </Box>
              )}

              <Tabs
                value={viewTabValue}
                onChange={handleViewChange}
                sx={{ ...classes.Tabs_01, marginLeft: "1.8rem" }}
                TabIndicatorProps={{
                  style: { backgroundColor: "transparent" },
                }}
              >
                <Tab
                  disableRipple
                  sx={{ ...classes.tab1, border: "1px solid #D9D9D9" }}
                  label="Performance"
                // icon={<img src={gridView_black} height="14rem" alt="" />}
                />
                <Tab
                  disableRipple
                  sx={{ ...classes.tab1, border: "1px solid #000000" }}
                  // icon={<img src={listView} alt="" />}
                  label="Card View"
                />
                {/* <Tab
                  disableRipple
                  sx={{ ...classes.tab1, border: "1px solid #000000" }}
                  // icon={<img src={listView} alt="" />}
                  label="List View"
                /> */}
              </Tabs>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { backgroundColor: "transparent" },
                }}
                sx={classes.Tabs}
              >
                <Tab
                  disableRipple
                  sx={classes.tabs}
                  onClick={() => handleTabClick(0)}
                  label="All"
                />
                <Tab
                  disableRipple
                  sx={classes.tabs}
                  onClick={() => handleTabClick(1)}
                  label="Mine"
                />
                <Tab
                  disableRipple
                  sx={classes.tabs}
                  onClick={() => handleTabClick(2)}
                  label="Team"
                />
                <Tab
                  disableRipple
                  sx={classes.tabs}
                  onClick={() => handleTabClick(3)}
                  label="Topic"
                />

                {/* )} */}
                {viewTabValue === 1 && (
                  <Tab
                    disableRipple
                    sx={classes.tabs}
                    onClick={() => handleTabClick(4)}
                    label="Archive"
                  />
                )}
              </Tabs>
            </Box>
            <Box display={"flex"} gap={"0.2rem"} marginTop={"1rem"}>
              {groupActive && sidebarLeft && (
                <>
                  <StyledSideBarGroupBox>
                    <Box
                      display="flex"
                      gap={"8px"}
                      alignItems="center"
                      sx={boxStyle}
                      justifyContent={"space-between"}
                    >
                      {/* <Box width={"73.2%"} mr={"6%"}> */}
                      <Box width={"100%"}>
                        <SearchBox>
                          <CustomInput
                            placeholder={appContent?.KEY122}
                            onChange={handleOnSearchGroup}
                          />
                          <ChatSearchButton size="small" variant="contained">
                            <SmallIcon src={searchIcon} />
                          </ChatSearchButton>
                        </SearchBox>
                      </Box>
                    </Box>

                    <Box
                      bgcolor={colorSchemes.boxBgColor}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mt={"0.4rem"}
                      rowGap={"0.4rem"}
                      overflow={"auto"}
                      height={"calc(100vh - 13.5rem)"}
                      sx={{
                        "&::-webkit-scrollbar": {
                          width: "0px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#F9F8F8",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "grey",
                        },
                        "@media (max-width: 1194px)": {
                          height: "calc(100vh - 15rem)",
                        },
                      }}
                    >
                      <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                        onDragStart={(event) => {
                          setActiveId(event.active.id);
                          // Prevent scrolling during drag
                          document.body.style.overflow = "hidden";
                        }}
                        onDragCancel={() => {
                          setActiveId(null);
                          // Restore scrolling after drag
                          document.body.style.overflow = "auto";
                        }}
                      >
                        <SortableContext
                          items={
                            Array.isArray(approvalTabGroupList)
                              ? approvalTabGroupList.map(
                                (item) => `${item.id}-groupListApproval`,
                              )
                              : []
                          }
                          strategy={verticalListSortingStrategy}
                        >
                          {Array.isArray(approvalTabGroupList) &&
                            approvalTabGroupList.length > 0 ? (
                            approvalTabGroupList.map((item, i) => (
                              <SortableItem
                                key={item?.id + "groupListApproval"}
                                item={item}
                                index={i}
                                selectedTaskTabGroup={selectedTabGroup}
                                handleSelectTaskTabGroup={
                                  handleSelectTabGroup
                                }
                              />
                            ))
                          ) : (
                            <Typography variant="body2">
                              No groups available
                            </Typography>
                          )}
                        </SortableContext>
                        <DragOverlay>
                          {activeId ? (
                            <div
                              style={{
                                background: "white",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "8px 12px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                opacity: 0.9,
                                pointerEvents: "none",
                                userSelect: "none",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {groupList.find(
                                (item, index) =>
                                  item?.id + "groupList" + index + "unique" ===
                                  activeId,
                              )?.name || "Dragging..."}
                            </div>
                          ) : null}
                        </DragOverlay>
                      </DndContext>
                    </Box>
                  </StyledSideBarGroupBox>
                </>
              )}
              {/* currentHomeIndexTab === 1 && showSidebar && isSideBarOpen && */}
              {viewTabValue !== 0 && filterActive && sidebarLeft && (
                <>
                  <Box sx={classes.taskApprovalSidebar}>
                    <Filter
                      setSideBarOpen={setSideBarOpen}
                      handleCheckedFilter={handleCheckedFilter}
                      filterChecked={filterChecked}
                      sidebarmenudata={approvalsidebarmenu}
                      filterbarmenudata={approvalsidebarmenu}
                      handleClearFilter={handleClearFilter}
                      handleApplyFilter={handleApplyTaskFilter}
                      currentHomeIndexTab={currentHomeIndexTab}
                      selectedDateRange={selectedDateRange}
                      setSelectedDateRange={setSelectedDateRange}
                    />
                  </Box>
                </>
              )}

              <Box
                width={TaskDetailWidth}
                sx={{
                  overflowY: "auto",
                  height: "calc(100vh - 10rem)",
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#B0B0B0",
                    borderRadius: "10px",
                  },
                }}
              >
                <Stack>
                  <TabPanel value={tabValue} index={0}>
                    {viewTabValue === 0 ? (
                      <Box sx={classes.analyticsParentBox}>
                        <ApprovalAnalytics
                          approvalTabValue={tabValue}
                          selectedTaskmember={selectedMember}
                        />
                      </Box>
                    ) : viewTabValue === 1 ? (
                      <ApprovalListComponent
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    ) : (
                      <ApprovalListPage
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    {viewTabValue === 0 ? (
                      <Box sx={classes.analyticsParentBox}>
                        <ApprovalAnalytics
                          approvalTabValue={tabValue}
                          selectedTaskmember={selectedMember}
                        />
                      </Box>
                    ) : viewTabValue === 1 ? (
                      <ApprovalListComponent
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    ) : (
                      <ApprovalListPage
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                    {viewTabValue === 0 ? (
                      <Box sx={classes.analyticsParentBox}>
                        <ApprovalAnalytics
                          approvalTabValue={tabValue}
                          selectedTaskmember={selectedMember}
                        />
                      </Box>
                    ) : viewTabValue === 1 ? (
                      <ApprovalListComponent
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    ) : (
                      <ApprovalListPage
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={3}>
                    {viewTabValue === 0 ? (
                      <Box sx={classes.analyticsParentBox}>
                        <ApprovalAnalytics
                          approvalTabValue={tabValue}
                          selectedTaskmember={selectedMember}
                        />
                      </Box>
                    ) : viewTabValue === 1 ? (
                      <ApprovalListComponent
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    ) : (
                      <ApprovalListPage
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={4}>
                    {viewTabValue === 0 ? (
                      <Box sx={classes.analyticsParentBox}>
                        <ApprovalAnalytics
                          approvalTabValue={tabValue}
                          selectedTaskmember={selectedMember}
                        />
                      </Box>
                    ) : viewTabValue === 1 ? (
                      <ApprovalListComponent
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    ) : (
                      <ApprovalListPage
                        approvalTabValue={tabValue}
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        handleViewThreadClick={handleViewThreadClick}
                        handleApplyTaskFilter={handleApplyTaskFilter}
                        filterChecked={filterChecked}
                      />
                    )}
                  </TabPanel>
                </Stack>
              </Box>
            </Box>
          </Box>
          <Drawer
            sx={{ zIndex: 1202 }}
            open={buttonDrawer?.isOpen}
            anchor="right"
          >
            {buttonDrawer?.header == "Team" && (
              <TaskTeamList
                recipientDetails={recipientDetails}
                handlecloseTeamlist={handlecloseTeamlist}
                handleSelectTaskMemberCheck={handleSelectMemberCheck}
                selectedTaskmember={selectedMember}
              />
            )}
            {buttonDrawer?.header == "Topic" && (
              <TaskTopicList
                handlecloseTopiclist={handlecloseTopiclist}
                handleSelectGroupTopic={handleSelectGroupTopic}
                selectedGroupTopic={selectedGroupTopic}
                groupTopicList={groupTopicList}
                groupSubtopicList={groupSubtopicList}
              />
            )}
          </Drawer>
        </Stack>

        {/* {(selectedTaskmember?.length > 0 ||
          selectedTaskGroup?.length > 0 ||
          filterChecked?.length > 0 ||
          approvalTabValue === 2 ||
          approvalTabValue === 3) && (
          <Box
            bgcolor={"#F3F3F3"}
            width={"100%"}
            display={"flex"}
            gap={"0.2rem"}
            alignItems={"center"}
          >
            <Box
              sx={{
                "::-webkit-scrollbar": {
                  height: "0px",
                },
              }}
              maxWidth={"53.8rem"}
              overflow={"auto"}
              display={"flex"}
              alignItems={"center"}
              gap={"0.2rem"}
            >
              <Box>
                {selectedTaskmember?.length > 0 && (
                  <Chip
                    label={`${selectedTaskmember[0]?.userInfo?.firstName} ${selectedTaskmember[0]?.userInfo?.lastName}`}
                    variant="outlined"
                    onDelete={() => handleRemoveSelectedTabFilter()}
                  />
                )}
              </Box>
              <Box display={"flex"} gap={"0.2rem"} alignItems={"center"}>
                {filterChecked?.length > 0 && (
                  <>
                    {filterChecked?.map((item) => (
                      <Chip
                        label={`${item?.type}`}
                        variant="outlined"
                        onDelete={() => handleRemoveStatusFilter(item)}
                      />
                    ))}
                  </>
                )}
              </Box>
              <Box>
                {selectedTaskGroup?.length > 0 && (
                  <Chip
                    label={`${selectedTaskGroup[0]?.name}`}
                    variant="outlined"
                    onDelete={() => handleRemoveSelectedTabFilter(false)}
                  />
                )}
              </Box>
            </Box>
            {approvalTabValue === 2 && (
              <Box alignSelf={"flex-end"} marginLeft={"auto"}>
                <Button
                  style={{
                    background: "#DB0011",
                    color: "white",
                    borderRadius: "3px",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() => handleClicktabButton("Team")}
                >
                  Select team Members
                </Button>
              </Box>
            )}

            {approvalTabValue === 3 && (
              <Box alignSelf={"flex-end"} marginLeft={"auto"}>
                <Button
                  style={{
                    background: "#DB0011",
                    color: "white",
                    borderRadius: "3px",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() => handleClicktabButton("Group")}
                >
                  Select Groups
                </Button>
              </Box>
            )}
          </Box>
        )} */}
      </Box>
    </>
  );
};

export default ApprovalListTab;
